<template>
<div>
    <v-dialog v-model="aktarimdialog" persistent max-width="500px">
        <v-card color="grey lighten-2">
            <v-flex xs12 sm12>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title class="baslikfont">{{dialogbaslik}}</v-toolbar-title>
                </v-toolbar>
            </v-flex>
            <v-card-text>
                <div class="flex md12">
                    <input type="file">
                    <v-checkbox :label="$t('Move-CardHolder-Reservation')" hide-details></v-checkbox>

                    <v-layout>
                        <v-select hide-details="" :items="itemsevraktipi" clearable item-text="Aciklama" item-value="Evrakkod" :label="$t('Document-Type')"></v-select>
                        <v-text-field hide-details="" :label="$t('Document-No')"></v-text-field>
                    </v-layout>
                    <v-text-field hide-details="" :label="$t('Description')"></v-text-field>
                    <v-layout>
                        <v-select hide-details="" :items="doviztipi" @change="kurgetir()" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-select>
                    </v-layout>
                    <v-layout>
                        <v-autocomplete :items="bankapositems" hide-details="" item-text="Title" item-value="PosKodu" clearable :label="$t('Pos-Code')"></v-autocomplete>
                        <v-select :items="taksitsayitahsilat" hide-details="" item-text="TaksitAciklama" item-value="TaksitID" clearable :label="$t('Instalment')"></v-select>
                    </v-layout>
                    <v-text-field hide-details="" :label="$t('Credit-Card-No')"></v-text-field>
                    <v-select :items="itemsbanka" hide-details="" item-text="BankaAdi" item-value="BankaKod" clearable :label="$t('Bank-Code')"></v-select>

                    <cariaracomp v-bind:etiket="$t('Select-Counter-Current')" :loading="loading" :rules="true" v-bind:value="EkstreHesap.Cari.Kod" v-model="EkstreHesap.Cari.Kod" v-bind:statecariyedek="statecaritahsilat"></cariaracomp>

                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="tahsilatdialog=false">{{$t('Cancel')}}</v-btn>
                <v-btn id="bkaydet" color="blue darken-1" flat @click="tahsilatkaydet()">{{ $t('Start-Transfer') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
    </v-card>
</div>
</template>

<script>
import auth from '../../../api/auth'
import tarihcomp from '../customcomp/tarihcomp'
import parainput from '@/components/app/customcomp/parainput.vue'
import dovizinput from '@/components/app/customcomp/dovizinput.vue'
import cariaracomp from '@/components/app/customcomp/cariaracomp'
export default {
    props: ["value"],
    components: {
        tarihcomp,
        parainput,
        dovizinput,
        cariaracomp
    },
    computed: {
        val: {
            get: function () {
                return this.value;
            },
            set: function (newValue) {
                this.$emit('input', newValue)
            },
        },
    },
    beforeMount: beforeMount,

    methods: {
        kurgetir(tarih, kod) {
            var params1 = {
                Tarih: tarih,
                DovizKod: kod
            }

            if (tarih != null && tarih != '') {
                this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params1, {
                    headers: auth.getAuthCompaniesInfo()
                  
                }).then((response) => {
                    if(response.body == 0.0){
                         this.val.Kur = 1
                    }else{
                        this.val.Kur = response.body
                    }
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-Kur Hesapla'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-Kur Hesapla'
                        this.snackbar = true
                    }
                })
            }

        },
        taksitgetirtahsilat(v) {
            var tumliste = []
            tumliste = this.bankapositems
            tumliste.forEach(element => {
                if (element.PosKodu == v) {
                    this.taksitsayitahsilat = []
                    this.taksitsayitahsilat = element.Taksitler
                }
            });
        },
        open(title) {

            if (title == 'aa') {
                this.dialogbaslik = 'Tahsilat Ekle'
                this.kaydetbuton = true
                this.tahsilatguncellebuton = false
            }

            if (title == 'update') {
                this.dialogbaslik = 'Tahsilat Güncelle'
                this.tahsilatguncellebuton = true
                this.kaydetbuton = false

                var seciliitems = [{
                    id: this.val.KarsiCari,
                    unvan1: this.val.KarsiCari,
                    unvan2: '',
                    autoText: this.val.KarsiCari + "-" + this.val.KarsiCari
                }]
                this.statecaritahsilat = seciliitems
            }

            this.aktarimdialog = true;
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });

        },
        tahsilatkaydet: tahsilatkaydet,
        tahsilatguncelle: tahsilatguncelle
    },
    data() {
        return {
            aktarimdialog: false,
            dialogbaslik: '',
            resolve: null,
            kaydetbuton: false,
            tahsilatguncellebuton: false,
            k: null,
            doviztipi: [],
            reject: null,
            bankapositems: [],
            itemsbanka: [],
            statecaritahsilat: [],
            itemsevraktipi: [],
            tahsilatdialog: false,
            text1: null,
            searchcaritahsilat: '',
            taksitsayitahsilat: [],
            loading: false,
            snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
        }
    },

    watch: {
    },
}

function tahsilatkaydet() {
    var paramstahsilat = this.val
    this.$http.post(auth.API_URL + 'api/Payment/DetailPaymentAdd', paramstahsilat, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
        this.tahsilatdialog = false
        this.resolve(true);
    }, (response) => {
        if (response.status === 0) {
            this.resolve(false);
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        } else {
            this.resolve(false);
            this.text1 = response.body.StatusText
            this.snackbar = true
        }
    })
}

function beforeMount() {


}

function tahsilatguncelle() {
    var paramstahsilat = this.val
    this.$http.post(auth.API_URL + 'api/Payment/DetailPaymentUpdate', paramstahsilat, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
        this.tahsilatdialog = false
        this.resolve(true);

    }, (response) => {
        if (response.status === 0) {
            this.resolve(false);

            this.text1 = 'Service Unavailable'
            this.snackbar = true
        } else {
            this.resolve(false);
            this.text1 = response.body.StatusText
            this.snackbar = true
        }
    })
}
</script>
